// 🔧 ticket_defaults.js
// ✅ Purpose: Provides default Ticket Engine demo data
// ✅ Features:
// - Industry-aware ticket type templates
// - Demo-size-aware ticket holder counts
// - Uses cents for currency values
// - Returns plain JavaScript objects only
// - Fully block-commented for clarity and future devs

import { getPowerUpProfile } from "../../../industries/power_up_profiles";

const GENERIC_TICKET_TYPES = [
  {
    localKey: "general-admission",
    name: "General Admission",
    description: "Standard attendee admission.",
    priceCents: 1000,
    quantityAvailable: 500,
  },
  {
    localKey: "student",
    name: "Student Ticket",
    description: "Discounted student admission.",
    priceCents: 500,
    quantityAvailable: 250,
  },
  {
    localKey: "vip-pass",
    name: "VIP Pass",
    description: "Premium event admission.",
    priceCents: 4000,
    quantityAvailable: 75,
  },
];

export const buildTicketDefaults = ({
  industryTemplate = "car_show",
  demoSize = "medium",
} = {}) => {
  const powerUpProfile = getPowerUpProfile(industryTemplate);
  const [participantName, participantDescription, participantPriceCents] =
    powerUpProfile.participantTicket;
  const typePool = [
    GENERIC_TICKET_TYPES[0],
    {
      localKey: "participant-entry",
      name: participantName,
      description: participantDescription,
      priceCents: participantPriceCents,
      quantityAvailable: 250,
    },
    GENERIC_TICKET_TYPES[2],
  ];

  const ticketTypes = typePool.map((type, index) => ({
    localKey: type.localKey,
    name: type.name,
    title: type.name,
    description: type.description,

    priceCents: type.priceCents,

    quantityAvailable: type.quantityAvailable,
    quantitySold: 0,

    currency: "usd",

    active: true,
    displayOrder: (index + 1) * 10,

    demoSeed: true,
  }));

  const ticketCount = getTicketCount(demoSize);
  const tickets = [];

  for (let index = 0; index < ticketCount; index += 1) {
    const displayName =
      powerUpProfile.passportPeople[
        index % powerUpProfile.passportPeople.length
      ];
    const nameParts = displayName.split(" ");
    const firstName = nameParts[0];
    const lastName = nameParts.slice(1).join(" ");

    const ticketType = ticketTypes[index % ticketTypes.length];

    tickets.push({
      ticketTypeLocalKey: ticketType.localKey,
      ticketTypeName: ticketType.name,

      firstName,
      lastName,
      purchaserName: `${firstName} ${lastName}`,
      purchaserEmail: `${firstName}.${lastName}.${index + 1}@example.com`.toLowerCase(),

      quantity: 1,
      amountPaidCents: ticketType.priceCents,

      paymentStatus: "paid",
      checkInStatus: index % 4 === 0 ? "checked_in" : "not_checked_in",
      checkedInAt: null,

      ticketCode: `DEMO-${String(index + 1).padStart(5, "0")}`,

      demoSeed: true,
    });
  }

  return {
    ticketTypes,
    tickets,
  };
};

const getTicketCount = (demoSize) => {
  switch (demoSize) {
    case "small":
      return 12;

    case "large":
      return 75;

    case "xlarge":
      return 150;

    case "medium":
    default:
      return 35;
  }
};
